import React from 'react';
import { useDispatch } from 'react-redux';
import Close from '../../Assets/Modals/closeIcon.svg';
// import { closeModal } from '../../Features/notificationsSlice';
import NotificationItem from './Components/NotificationItem';
import { useSelector } from 'react-redux';
import { markAllNotificationsAsRead } from '../../lib/utils/apiCalls';
import { fetchNotifications } from '../../Features/notificationsSlice';
import { showToast } from '../../Components/Toaster/Toaster';

function Notifications() {
    const dispatch = useDispatch();
    const notifications = useSelector((state) => state.notifications.notifications.notifications);

    const handleCloseButton = () => {
        // To be checked what cross button does
    }

    // To be updated
    const handleMarkAllAsRead = async () => {
        try {
            const response = await markAllNotificationsAsRead();
            if(response?.status === 200) {
                dispatch(fetchNotifications());
            }
        }
        catch(err) {
            // eslint-disable-next-line eqeqeq
            if(err.response.data.statusCode == 10001) {
                showToast(err.response.data.message);
            }
            else {
                console.log('Error occurred:', err);
            }
        }
    }

    return (
        <div className='mt-8 mx-auto w-[45%]'>
            <div className="flex items-center justify-between py-3 pl-3 border-b border-[#EAEAEA]">
                <h1 className='select-none font-medium text-2xl text-[#121212]'>Notifications</h1>

                <div className="flex items-center gap-[2px]">
                    <button onClick={handleMarkAllAsRead} className='select-none outline-none border-none underline text-[#1055EB] font-medium text-[14px] leading-[22px]'>Mark all as read</button>

                    <div className="size-11 flex items-center justify-center">
                        <img onClick={handleCloseButton} className='cursor-pointer select-none' src={Close} alt="close" />
                    </div>
                </div>
            </div>

            <div className="flex flex-col overflow-y-scroll max-h-[462px]">
                {notifications.map(notification => {
                    return (
                        <NotificationItem 
                            key={notification.id} 
                            notification={notification} 
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default Notifications;
